//@flow app-wide store not needed at the moment

import { Map as OrderedMap } from "immutable";

import { ReduceStore } from "flux/utils";

import Dispatcher from "./Dispatcher";
import { ActionTypes } from "./actions";
// import { AudioSource, SourceType } from '../audioplayer/source'

class Store extends ReduceStore<Object> {
  constructor() {
    super(Dispatcher);
  }

  getInitialState(): Object {
    return OrderedMap({
      duration: 0,
      currentTime: 0,
      hidePanel: true,
      desiredPlayState: false,
      // isPlaying: false,
      // isBuffering: true,
      playState: "PAUSED",
      currentSrc: null,
      volume: 80,
      mute: false,
    });
  }

  reduce(state: Object, action: Object): Object {
    switch (action.type) {
      case ActionTypes.TOGGLE_PLAY:
        const v = state.get("desiredPlayState");
        return state.set("desiredPlayState", !v);
      case ActionTypes.SET_DESIRED_PLAY_STATE:
        return state.set("desiredPlayState", action.value);
      case ActionTypes.SET_PLAY_STATE:
        return state.set("playState", action.value);
      // case ActionTypes.SET_CURRENT_AUDIO_NAME:
      //   return state.set("audioName", action.value);
      case ActionTypes.SET_CURRENT_SRC:
        return state.set("currentSrc", action.value);
      // case ActionTypes.SET_IS_BUFFERING:
      // return state.set("isBuffering", action.value);
      case ActionTypes.SET_CURRENT_TIME:
        return state.set("currentTime", action.value);
      case ActionTypes.SET_DURATION:
        return state.set("duration", action.value);
      case ActionTypes.SET_HIDE_PANEL:
        return state.set("hidePanel", action.value);
      case ActionTypes.SET_IS_MUTED:
        return state.set("mute", action.value);
      case ActionTypes.SET_VOLUME:
        return state.set("volume", action.value);
      default:
        return state;
    }
  }
}

export default (new Store(): Object);
